import axios from 'axios';
import { createSignedPatchRequest } from 'utils/createSignedRequestsHelpers';

export const patchUpdateOrganizationChartItemUserIds = async ({
  projectId,
  organizationChartItemId,
  userIds,
}) => {
  const apiPath = `organization-charts/project/${projectId}/organization/${organizationChartItemId}/update-user-ids`;

  const signedRequest = await createSignedPatchRequest({
    apiPath,
    body: { userIds },
  });

  const response = await axios(signedRequest);

  return response.data;
};
